export const tableTypeNameMapping = (type) => {
  const nameMapping = {
    entity: "Entity Data",
    statemachine: "SM-Workflow",
    activity: "Activity Tracker",
    rdbms: "RDBMS",
    postgres: "PostgreSQL",
    appuser: "Application User",
    // communityuser: "Community User",
    RvTemplate: "Recordview Template"
  };
  return nameMapping[type] || type;
};
